import ApiService from "@/common/api/api.service";

const AlertaService = {
  listar(usuarioId) {
    return ApiService.get(`Alerta?usuarioId=${usuarioId}`);
  },
  listarPendentes(usuarioId) {
    return ApiService.get(`Alerta/nao-visualizado?usuarioId=${usuarioId}`);
  },
  remover(id) {
    return ApiService.delete(`Alerta`, { id });
  },
  removerLista(form) {
    return ApiService.delete(`Alerta/varios`, form);
  },
  visualizar(id) {
    return ApiService.put(`Alerta?id=${id}`);
  },
  buscar(id) {
    return ApiService.get(`Alerta/${id}`);
  },
  retornaQuantidadeAlertas(usuarioId) {
    return ApiService.get(`Alerta/quantidade?usuarioId=${usuarioId}`);
  }
};

export default AlertaService;
